import axios, { isAxiosError } from "axios";
import { useEffect, useState } from "react"
import Select from "react-dropdown-select";
import { useSelector } from "react-redux";
import Loadingwrapper from "../../component/LoadingWrapper"
import TrendImagesType from "./TrendImagesType";
import roundtocloses0_5_value from "./Utils/roundToClosest_0_5";
import showFloatToPercentage from "./Utils/showFloatToPercentage";

const RatingOptions = [
  { label: 'Unrated', value: 'unrated' },
  { label: '1 Star +', value: '1' },
  { label: '2 Star +', value: '2' },
  { label: '3 Star +', value: '3' },
  { label: '4 Star +', value: '4' },
  { label: '5 Star +', value: '5' },
]

const PriceOptions = [
  { label: '0-1000', value: '0-1000' },
  { label: '1000-2000', value: '1000-2000' },
  { label: '2000-3000', value: '2000-3000' },
  { label: '3000-4000', value: '3000-4000' },
  { label: '4000-5000', value: '4000-5000' },
  { label: '5000+', value: '5000' },
]

const TrendImages = ({ trendType, searchParams, setSearchParams, tag, value, isPage = false, category, isCoord = false, selectedretailer }) => {
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(1)
  const [brandCounts, setBrandCounts] = useState([])
  const [retailerCounts, setRetailerCounts] = useState([])
  const [pricesSelected, setPricesSelected] = useState([])
  const [RatingSelected, setRatingsSelected] = useState([])
  const [selectedBrand, setSelectedBrand] = useState(null)
  const [imagesSort, setImagesSort] = useState(searchParams.get('imagesSort') || 'recency')
  const [socialLoading, setSocialLoading] = useState(false)
  const [retailerLoading, setRetailerLoading] = useState(false)
  const userLoggedIn = useSelector(state => state.userLoggedIn)
  const [retailerProducts, setRetailerProducts] = useState([])
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const limit = 100


  useEffect(() => {
    if (searchParams.get('brand')) {
      setSelectedBrand(searchParams.get('brand'))
    }
  }, [])

  useEffect(() => {
    setImagesSort(searchParams.get('imagesSort') || 'recency')
  }, [searchParams.get('imagesSort')])

  useEffect(() => {
    setCount(1)
    setPage(1)
  }, [selectedBrand])

  const downloadRetailerProducts = async () => {

    try {
      const gender = searchParams.get('gender') == 'F' ? 'Female' :
        searchParams.get('gender') == 'M' ? 'Male' :
          searchParams.get('gender') ? searchParams.get('gender') :
            'Female'

      const categoryOfImages = category ? category : searchParams.get('category')
      setButtonDisabled(true)
      const resp = await axios.get(`/social-trends-v2-api/leaderboard-trend-images/retailer?gender=${gender}&category=${encodeURIComponent(categoryOfImages)}&geography=${searchParams.get('geography') || 'All'}&source=${searchParams.get('source') || ''}&time=${''/*searchParams.get('time') || '30 days'*/}&page=${page || 1}&limit=10000${searchParams.get('tag') ? `&tag=${encodeURIComponent(searchParams.get('tag'))}` : ''}${searchParams.get('value') ? `&value=${encodeURIComponent(searchParams.get('value'))}` : ''}&trendTag=${encodeURIComponent(tag)}&trendValue=${encodeURIComponent(value)}&retailer=${encodeURIComponent(selectedretailer)}${trendType === 'retailer' && selectedBrand != null ? `&brand=${encodeURIComponent(selectedBrand)}` : ''}&sort=${imagesSort || 'recency'}${isCoord ? `&coord=true` : ''}`)
      const retailerProducts = resp.data.images
      retailerProducts.forEach(prod => {
        prod.forecastValue = prod.forecastScore && Object.values(prod.forecastScore).length > 0 ? Object.values(prod.forecastScore)[0] : 0
      })
      retailerProducts.sort((a, b) => {
        return b.forecastValue - a.forecastValue
      })
      let productStrings = []
      for (let product of retailerProducts) {
        productStrings.push(`"${product.ecommerce_id}","${product.product_url}","${product.image_url}","${roundtocloses0_5_value(showFloatToPercentage(product.forecastValue))}","${product.brand}"`)
      }

      const text = 'product id,product url,image url,forecast score,brand name\n' + productStrings.join('\n')

      let element = document.createElement('a');
      element.setAttribute('href',
        'data:text/plain;charset=utf-8, '
        + encodeURIComponent(text.trim()));
      element.setAttribute('download', `${tag}--${value}.csv`);
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
        throw e
      }
    }

    setButtonDisabled(false)

  }


  const updateImagesSort = (newValue) => {
    setSearchParams(prev => {
      prev.set('imagesSort', newValue)
      return prev
    })
  }

  return <div className={`${isPage ? "" : "w-[80vw] h-[80vh]"} bg-white`}>
    {isPage ? <div className="w-full my-8"></div> : <div className="flex justify-end">
      <button onClick={() => {
        const sEntries = searchParams.entries()
        let urlStringOfSearchParam = ''
        for (let s of sEntries.toArray()) {
          if (s[0] != 'category')
            urlStringOfSearchParam = urlStringOfSearchParam + `&${s[0]}=${s[1]}`
        }
        window.navigator.clipboard.writeText(`${window.location.host}/v2-trend?trends=${trendType}&category=${category}&selectedtag=${encodeURIComponent(tag)}&selectedvalue=${encodeURIComponent(value)}${urlStringOfSearchParam}${isCoord ? '&coord=true' : ''}${selectedretailer ? `&selectedretailer=${encodeURIComponent(selectedretailer)}` : ''}`)
      }}
        className="primary-btn text-sm py-1"
      >Copy URL</button>
    </div>}
    <h3 className="text-center font-semibold text-[20px]">{value != '#N/A' ? value : 'No Specific'} {tag} Trend Images</h3>

    <div className="flex justify-end">
      <div className="mx-2">
        <button className="primary-btn" onClick={() => { setPage(prev => prev - 1) }} disabled={page <= 1}>prev</button> {page}/{Math.ceil(count / limit)}
        <button className="primary-btn" onClick={() => { setPage(prev => prev + 1) }} disabled={page >= Math.ceil(count / limit)}>next</button>
      </div>
    </div>
    <div className="flex justify-end pl-2">
      <button
        disabled={buttonDisabled}
        className="rounded-full bg-blue-600 active:bg-blue-800 disabled:bg-blue-300 hover:bg-blue-700 px-6 py-1 text-white my-2 mx-2"
        onClick={downloadRetailerProducts}
      >Download Retailer Data</button>
    </div>
    {userLoggedIn && userLoggedIn.loggedIn ? <>
      <div className="flex justify-start pl-2">
        <select value={trendType} onChange={e => setSearchParams(prev => {
          prev.set('trends', e.target.value)
          return prev;
        })}
          className='rounded px-2 py-1 font-semibold text-xs mx-2 border '>
          <option value={''} disabled>--Trend Type--</option>
          <option value={'both'}>Social & Retailer</option>
          <option value={'social'}>Social</option>
          <option value={'retailer'}>Retailer</option>
        </select>
        <select value={imagesSort} onChange={e => updateImagesSort(e.target.value)} className='bg-slate-100 rounded px-2 py-1 font-semibold text-xs border-slate-300 border '>
          <option value={''} disabled>--Image Sort--</option>
          <option value={'recency'}>Sort by Date</option>
          <option value={'forecast-value'}>Sort by Category Forecast Value</option>
          {false ? <option value={'Success points'} hidden>Success Points</option> : null}
        </select>
        {isPage ? <select className='px-2 rounded  border-slate-300 border mx-1' value={searchParams.get('time')} onChange={(e) => {
          setSearchParams(prev => {
            prev.set('time', e.target.value);
            return prev;
          })
        }}>
          <option value={""}>All Time</option>
          <option value={"7 days"}>7 days</option>
          <option value={"15 days"}>15 days</option>
          <option value={"30 days"}>30 days</option>
          <option value={"45 days"}>45 days</option>
          <option value={"60 days"}>60 days</option>
          <option value={"90 days"}>90 days</option>
          <option value={"180 days"}>180 days</option>
        </select> : null}
        <select className='px-2 rounded  border-slate-300 border mx-1' value={selectedretailer} onChange={(e) => {
          setSearchParams(prev => {
            prev.set('selectedretailer', e.target.value);
            return prev;
          })
        }}>
          <option value={""}>All Retailers</option>
          {retailerCounts.map(retailer => <option value={retailer.name}>{retailer.name}</option>)}
        </select>
        <Select
          placeholder="Select Price"
          options={PriceOptions}
          multi={true}
          onChange={(next) => {
            setPricesSelected(next.map(v => v.value))
          }}
          values={PriceOptions.filter(v => pricesSelected.includes(v.value))}
        />

        <Select
          placeholder="Select Ratings"
          options={RatingOptions}
          multi={true}
          onChange={(next) => {
            setRatingsSelected(next.map(v => v.value))
          }}
          values={RatingOptions.filter(v => RatingSelected.includes(v.value))}
        />
      </div>
      <div className="flex justify-between">
        {!selectedretailer ? <div>
          <div className="flex  border-slate-200 overflow-x-auto h-13 py-2 hover:h-auto w-[60vw] hover:flex-wrap transition-[height] transition-all duration-1000">
            {brandCounts.map(brand => <button
              key={brand._id}
              onClick={() => {
                setSelectedBrand(prev => {
                  return brand._id != prev ? brand._id : null
                })
              }}
              className={` text-nowrap border rounded-2xl px-2 text-xs font-medium hover:bg-slate-100 ${selectedBrand == brand._id ? "bg-slate-300" : "bg-white"} py-1 ml-1`}
            >{brand._id}({brand.count})</button>)}
          </div>
        </div> : null}
      </div>
    </> : null}

    <div className={`flex justify-between ${socialLoading || retailerLoading ? 'hidden' : ''}`} >
      {trendType != 'retailer' ? <TrendImagesType trendType={'social'} searchParams={searchParams} tag={tag} value={value} imagesSort={imagesSort} setCount={setCount} setBrandCounts={setBrandCounts} setLoading={setSocialLoading} page={page} category={category} isCoord={isCoord} selectedTrendType={trendType} /> : null}
      {trendType == 'both' ? <div className="w-0.5 bg-black"></div> : null}
      {trendType != 'social' ? <TrendImagesType trendType={'retailer'} searchParams={searchParams} tag={tag} value={value} imagesSort={imagesSort} setCount={setCount} setBrandCounts={setBrandCounts} setLoading={setRetailerLoading} selectedBrand={selectedBrand} page={page} category={category} isCoord={isCoord} selectedRetailer={selectedretailer} setRetailerCounts={setRetailerCounts} setParentRetailerProducts={setRetailerProducts} selectedTrendType={trendType} priceOptionSelected={pricesSelected} ratingOptionsSelected={RatingSelected} /> : null}
    </div>
    <Loadingwrapper loading={socialLoading || retailerLoading}>
    </Loadingwrapper>

    <div className="flex justify-end">

      <div className="">
        <button className="primary-btn" onClick={() => { setPage(prev => prev - 1) }} disabled={page <= 1}>prev</button> {page}/{Math.ceil(count / limit)}
        <button className="primary-btn" onClick={() => { setPage(prev => prev + 1) }} disabled={page >= Math.ceil(count / limit)}>next</button>
      </div>
    </div>

  </div >
}

export default TrendImages
